function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import callToAction from './callToAction.js';
import link from './link.js';
import requiredImage from '../fragments/requiredImage.js';
import simpleBlockContent from '../fragments/simpleBlockContent.js';
var schema = defineObject('largeHero', {
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    primaryImage: _object_spread({
        title: 'Primary Image'
    }, requiredImage.fragment),
    secondaryImage: _object_spread({
        title: 'Secondary Image'
    }, requiredImage.fragment),
    actionLabel: {
        title: 'Action label',
        type: 'string'
    },
    action: {
        title: 'Action',
        type: 'callToAction'
    }
}, [
    link.schema.link,
    callToAction.schema.callToAction
]);
var validator = z.object({
    title: z.string(),
    description: simpleBlockContent.validator,
    primaryImage: requiredImage.validator,
    secondaryImage: requiredImage.validator,
    actionLabel: z.string(),
    action: callToAction.validator
}).partial();
schema.largeHero;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=largeHero.js.map